import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import styled from "styled-components";
import arrowLeft from "../assets/bi_arrow-left.svg";
import drivers1 from "../assets/drivers1.svg";
import drivers2 from "../assets/drivers2.svg";

const DriversDetails = () => {
  return (
    <Wrapper>
      <Container>
        <Row className="about">
          <Col className="about__header__col">
            <div className="about__header">
              <h1>Join our growing network of Drivers.</h1>

              <p>
                If you own a vehicle and you need a way to make money, sign up
                as a driver on wecanrush and open a whole new stream of income.
              </p>
            </div>
          </Col>
          <div className="about__header__col">
            <div className="about__header_img">
              <img src={drivers1} alt="img" />
            </div>
          </div>
        </Row>
      </Container>
      <div className="about__section2">
        <Container>
          <Row className="about__section2__row">
            {/* <div className="about__second"> */}
            <Col className="about__section2__col">
              <div className="about__header2_img">
                <img src={drivers2} alt="img" />
              </div>
            </Col>

            <Col className="about__section2__col">
              <div className="about__header2">
                <h1>What you need to get started</h1>

                <p>
                  A smartphone (iOS / Android) that supports our Wecanrush
                  Driver app <br /> A vehicle (car, pickup, van, or truck) Your
                  ID, a valid driving license and a proof of right to work And
                  that’s it!
                </p>

                <button>
                  Get Started
                  <img src={arrowLeft} alt="arrow left" />
                </button>
              </div>
            </Col>
            {/* </div> */}
          </Row>
        </Container>
      </div>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  @media screen and (max-width: 440px) {
    .about__header__col .about__header_img img {
      width: 100% !important;
      height: auto !important;
      margin-left: 0px !important;
      padding: 16px;
    }

    .about__card {
      text-align: center;
      img {
        width: 165px;
        max-height: 163px;
        object-fit: cover;
      }

      .about__card__body {
        h1 {
          font-family: Manrope;
          font-style: normal;
          font-weight: bold;
          font-size: 20px;
          line-height: 27px;
          width: 100%;
          height: 27px;
          color: #232937;
        }
        h6 {
          font-family: Manrope;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 19px;
          width: 100%;
          height: 19px;
          color: #8492a6;
        }
      }
    }

    .about__foot__card {
      margin-top: 25px;
      margin-left: 6px;
    }

    .about__header {
      margin-top: 100px;
      width: 100%;
      h1 {
        font-family: Gilroy-Heavy;
        font-size: 42px !important;
        line-height: 54px;
        color: #6300ff;
        width: 100%;
        height: 110px;
      }
      p {
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 28px;
        color: #777e91;
        width: 100%;
        height: auto;
        margin-top: 40px;
        -webkit-letter-spacing: 0.6px;
        -moz-letter-spacing: 0.6px;
        -ms-letter-spacing: 0.6px;
        letter-spacing: 0.6px;
      }
    }

    .about__header2 {
      h1 {
        font-family: Gilroy-Heavy !important;
        font-size: 29px !important;
        line-height: 46px !important;
        color: #6300ff !important;
        width: 100% !important;
        height: 92px !important;
      }
      p {
        font-family: "Manrope" !important;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 16px !important;
        line-height: 28px !important;
        color: #777e91;
        width: 100%;
        height: auto;
        margin-top: 40px;
        -webkit-letter-spacing: 0.6px;
        -moz-letter-spacing: 0.6px;
        -ms-letter-spacing: 0.6px;
        letter-spacing: 0.6px;
      }
    }

    .about__section3 {
      h1 {
        font-family: Gilroy-Heavy !important;
        font-size: 35px !important;
        line-height: 35px !important;
        text-align: center !important;
        color: #6300ff !important;
      }
      p {
        font-family: Manrope !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 16px !important;
        line-height: 22px !important;
        text-align: center !important;
        color: #8492a6 !important;
        margin-top: 20px !important;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .about__header__col {
      width: 100%;
      .about__header {
        margin-top: 100px;
        width: 100%;
        h1 {
          font-family: Gilroy-Heavy;
          font-size: 56px;
          line-height: 54px;
          color: #6300ff;
          width: 100%;
          height: 110px;
        }
        p {
          font-family: Manrope;
          font-style: normal;
          font-weight: 500;
          font-size: 18px;
          line-height: 28px;
          color: #777e91;
          width: 100%;
          height: auto;
          margin-top: 40px;
          -webkit-letter-spacing: 0.6px;
          -moz-letter-spacing: 0.6px;
          -ms-letter-spacing: 0.6px;
          letter-spacing: 0.6px;
        }
      }
    }

    .about__header__col {
      width: 100%;
      .about__header_img {
        width: 100%;
        padding: 80px 0 50px 0;
        img {
          width: 100% !important;
          height: auto !important;
          margin-left: 0px !important;
        }
      }
    }

    .about__header2_img {
      margin-left: 0px !important;
      width: 100%;
      padding: 100px 0;
      img {
        width: 100% !important;
        height: auto !important;
        margin-left: 0px !important;
      }
    }
    .about__section2__row.row {
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-content: center;
      .about__header2 {
        margin-top: 0;
        margin-left: 0px;
        width: 100% !important;
        h1 {
          font-family: Gilroy-Heavy;
          font-size: 36px;
          line-height: 46px;
          color: #6300ff;
          width: 100%;
          height: 92px;
        }
        p {
          font-family: "Manrope";
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 28px;
          color: #545777;
          width: 100%;
          height: auto;
          margin-top: 26.68px;
        }
        button {
          font-family: Gilroy;
          font-style: normal;
          font-weight: 800;
          font-size: 18px;
          line-height: 22px;
          color: #1292ee;
          width: 50%;
          padding-left: 12px;
          height: 40px;
          display: -webkit-box;
          display: -webkit-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-pack: justify;
          -ms-flex-pack: justify;
          -webkit-align-items: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          justify-content: flex-start;
        }
      }
    }
    .about__card {
      margin-top: 56px;
      img {
        width: 100% !important;
        height: 355px;
        object-fit: cover;
        border-radius: 12px;
      }
    }
  }

  .about__section2__row.row {
    padding-bottom: 70px;
    /* margin-left: 15px; */
  }

  .about__header {
    margin-top: 100px;
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 42px;
      line-height: 57px;
      color: #6300ff;
      width: 420px;
      height: 92px;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: #777e91;
      width: 445px;
      height: 83px;
      margin-top: 40px;
      letter-spacing: 0.6px;
    }
  }

  .about__header_img img {
    width: 523.39px;
    height: 607.29px;
    margin-left: 25px;
  }

  .about__header2 {
    margin-top: 158px;
    margin-left: 110px;

    button {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 18px;
      line-height: 22px;
      color: #1292ee;
      width: 150px;
      height: 52px;
      border: none;
      outline: none;
      border-radius: 5px;
      position: relative;
      background: transparent;
    }

    button::before {
      content: "";
      width: 50%;
      height: 100%;
      background: rgba(18, 146, 238, 0.1);
      left: 0;
      top: 0;
      position: absolute;
      border-radius: 5px;
      transition: 0.4s all;
    }

    button:hover::before {
      width: 100%;
      border-radius: 5px;
    }
    button img {
      margin-left: 12px;
    }
  }

  .about__header2_img {
    margin-left: -40px;
    img {
      width: 523.39px;
      height: 607.29px;
      margin-left: -25px;
    }
  }

  .about__section2 {
    background: #e5edfc;
    margin-top: 110px;
    padding-top: 112px;

    h1 {
      font-family: Gilroy-Heavy;
      font-size: 36px;
      line-height: 46px;
      color: #6300ff;
      width: 430px;
      height: 92px;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: #545777;
      width: 445px;
      height: 140px;
      margin-top: 26.68px;
    }
    h6 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 18px;
      line-height: 22px;
      color: #1292ee;
      width: 130px;
      height: 25px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .about3.row {
    margin-top: 150px;
  }

  .about__section3 {
    text-align: center;
  }

  .about__section3 {
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 48px;
      line-height: 56px;
      text-align: center;
      color: #6300ff;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 27px;
      text-align: center;
      color: #8492a6;
      letter-spacing: 0.8px;
      margin-top: 10px;
    }
  }

  .about__card img {
    width: 340px;
    height: 355px;
    object-fit: cover;
    border-radius: 12px;
  }

  .about__card__body {
    h1 {
      font-family: Manrope;
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 33px;
      color: #232937;
      margin-top: 38px;
    }

    h6 {
      font-family: "Manrope";
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 21px;
      color: #8492a6;
      width: 200px;
      height: 26px;
    }
  }

  .about__card {
    margin-top: 56px;
  }

  .about__footer_head {
    margin-top: 200px;
    h1 {
      font-family: "Gilroy";
      font-style: normal;
      font-weight: 900;
      font-size: 48px;
      line-height: 54px;
      text-align: center;
      letter-spacing: -0.4625px;
      color: #2c5282;
      width: 100%;
    }
    p {
      font-family: "Gilroy";
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 38px;
      text-align: center;
      color: #8492a6;
    }
  }

  .about__footer {
    margin-top: 100px;
  }

  .card_img img {
    width: 350px;
    height: 224px;
  }
  .about__foot__card {
    width: 350px;
    height: 406px;
    background: #ffffff;
    box-shadow: 0px 13px 18px rgb(57 84 255 / 4%);
    border-radius: 10px;
  }

  .about__foot__title.card-title.h5 {
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #8492a6;
    display: flex;
    align-items: center;
    margin-top: 15px;
    img {
      margin-right: 15.6px;
    }
  }
  p.about__foot__des {
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 27px;
    color: #232937;
    margin-top: 15px;
  }
`;

export default DriversDetails;
